export const PRODUCT_DRAWING_FILE_ACCEPT =
  'application/pdf,image/jpeg,image/png,image/webp,image/svg+xml,' +
  '.pdf,.jpg,.jpeg,.png,.webp,.svg'

export function isAllowedProductDrawingFile(file: File): boolean {
  const lowerCaseFileName = file.name.toLowerCase()
  return (
    file.type === 'application/pdf' ||
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'image/webp' ||
    file.type === 'image/svg+xml' ||
    lowerCaseFileName.endsWith('.pdf') ||
    lowerCaseFileName.endsWith('.jpg') ||
    lowerCaseFileName.endsWith('.jpeg') ||
    lowerCaseFileName.endsWith('.png') ||
    lowerCaseFileName.endsWith('.webp') ||
    lowerCaseFileName.endsWith('.svg')
  )
}
